import { FieldValues, useController, useFormContext } from 'react-hook-form';
import { FieldProps } from '../../../../generic/FieldProps';
import { BirthplaceInput } from '../../../BasePersonInputs/Birthplace/BirthplaceInput';

export function BirthplaceField<TValues extends FieldValues>({
  name,
}: FieldProps<TValues>) {
  const { control } = useFormContext<TValues>();
  const {
    field: { value, onChange },
  } = useController({
    name,
    control,
  });
  return (
    <BirthplaceInput
      value={value as string}
      onChange={onChange}
      label='Gründungsort'
    />
  );
}
